module.exports = __webpack_public_path__ + "img/18.05d31aaa.jpg";